export enum TargetGroupsStateIntent {
  AddTargetGroups = 'add-to-project',
  ReuseTargetGroups = 'reuse',
  EditTargetGroupTemplate = 'edit-target-group-template',
  EditDraft = 'edit-draft',
  ReplaceTargetGroups = 'replace-target-groups',
}
